.content {
  line-height: 2rem;
}
